import { componentSearchBar } from 'components/component-overview/state/component-search-bar';
import { useSnapshot } from 'hooks/use-safe-snapshot';

const useComponentSearchBar = () => {
    const componentSearchBarSnapshot = useSnapshot(componentSearchBar);

    return {
        ...componentSearchBarSnapshot,
        setQuery: (query: string) => {
            componentSearchBar.query = query;
        },
    };
};

export { useComponentSearchBar };
